import { getRequestHttpStatus } from '#shared/lib/errorBooster';

export const getEmailAuthErrorMessage = (error: unknown): string => {
    switch (getRequestHttpStatus(error)) {
        case 404:
            return 'Вход по почте сейчас недоступен. Попробуйте позже.';

        case 429:
            return 'Слишком много попыток. Попробуйте отправить письмо позже.';

        default:
            return 'Не удалось отправить письмо. Попробуйте ещё раз.';
    }
};
